import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {commentsIcon} from "../../assets/svg-paths";

function DidYouKnow(props) {
    const {color, size, bubbleOnLeft, children, store} = props;

    const [open, setOpen] = useState(false);

    let className = 'DidYouKnow';

    const {mobileMode} = store.interactionsStore;
    const content = () => {
        if (!open) return null;
        let contentClass = 'content';
        if (bubbleOnLeft) {
            contentClass += ' bubble-on-left';
        }
        return (<div className={contentClass}>
            <div className={'close-btn'} onClick={() => setOpen(false)}>x</div>

            {children}
        </div>)
    };

    const r = size / 2;
    return (
        <div className={className}>
            <div className={'icon'}>
                <svg width={r * 2} height={r * 2}>
                    <g className={className}
                       transform={`translate(${r},${r}) scale(${r / 18})`}//based on how big the heptagon is
                       onClick={() => {
                           setOpen(!open);
                       }}
                       onMouseEnter={(e) => {
                           if (mobileMode) return;//click event will open/close it on mobile...
                           setOpen(true);
                       }}

                       onMouseLeave={() => setOpen(false)}
                    >
                        <path
                            fill={color}
                            d="M -0.01504269,16.83729 -13.21038,10.482748 -16.469361,-3.7957765 -7.337905,-15.246267 7.3078198,-15.246268 16.439283,-3.7957777 13.180303,10.482747 Z"/>
                        <g transform={'scale(0.07) translate(-150,-70)'}>
                            <path fill={'#ffffff'} d={commentsIcon}/>
                        </g>
                    </g>

                </svg>
            </div>
            {content()}
        </div>

    );
}

DidYouKnow.defaultProps = {
    color: '#ff0000',
    size: 100,
};

export default observer(DidYouKnow);
